module.exports = __webpack_public_path__ + "img/rtd.5d2fa00b.png";